export default __webpack_public_path__ + "static/media/chamath2x.51ff7c74.png";